<template>
  <OffersList
    v-if="cptdRequestedOffersList.length"
    title="Continuar solicitação"
  >
    <RequestedOfferCardTemplateMethodContainer
      v-for="offer in cptdRequestedOffersList"
      :key="offer.offer_id"
      v-bind="$attrs"
      :offer="offer"
    />
  </OffersList>
</template>
<script>
import { mapGetters } from 'vuex'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import RequestedOfferCardTemplateMethodContainer from '@/containers/loans/RequestedOfferCardTemplateMethodContainer.vue'
export default {
  name: 'RequestedOffersListContainer',
  components: {
    OffersList,
    RequestedOfferCardTemplateMethodContainer,
  },
  computed: {
    ...mapGetters({
      gtAllOnGoingAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllOnGoingAutoOffers',
      gtAllOnGoingNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllOnGoingNoCollateralOffers',
      gtAllOnGoingHomeEquityOffers:
        'products/loans/home-equity/home-equity/gtAllOnGoingHomeEquityOffers',
    }),
    cptdRequestedOffersList() {
      return [
        ...this.gtAllOnGoingNoCollateralOffers,
        ...this.gtAllOnGoingAutoOffers,
        ...this.gtAllOnGoingHomeEquityOffers,
      ]
    },
  },
}
</script>
<style lang="scss"></style>
